import { ApiError } from "@/shared/api/errors";

const API_ERROR_MESSAGES: Readonly<Record<string, string>> = {
  VALIDATION_ERROR:
    "入力内容を確認してください。投稿本文は4000文字以内で入力してください",
  INVALID_REQUEST: "リクエスト内容を確認してください",
  SPAM_REJECTED:
    "スパム判定により投稿を受け付けられませんでした。内容を変更してお試しください",
  ROLE_FORBIDDEN:
    "この操作には参加期間が足りません。参加期間を満たしてからお試しください",
};
const BAD_REQUEST_MESSAGE = "入力内容を確認してください";
const LEGACY_SPAM_REJECTED_MESSAGE = "投稿を受け付けられませんでした";
const LEGACY_NSFW_REJECTED_MESSAGE =
  "画像が現在のR18設定では投稿できません。画像を変更するか、スレッドのR18設定を確認してください";
const NSFW_REJECTED_MESSAGE =
  "この画像は現在のR18設定では投稿できません。画像を変更してお試しください";
const NSFW_IMAGE_CHANGE_MESSAGE = "画像を変更してお試しください";
const R18_THREAD_SETTING_HINT =
  "R18相当の画像を含む新規スレッドの場合は、「R18画像を許可」を確認してください";

const GENERIC_API_ERROR_MESSAGES = new Set([
  "Bad Request",
  "Unprocessable Entity",
  "Forbidden",
  "Not Found",
  "Internal Server Error",
  "Service Unavailable",
]);

function getServerMessage(
  error: ApiError,
  legacyMessage: string,
): string | undefined {
  if (
    !error.message.trim() ||
    error.message === legacyMessage ||
    GENERIC_API_ERROR_MESSAGES.has(error.message) ||
    /^HTTP \d+$/.test(error.message)
  ) {
    return undefined;
  }
  return error.message;
}

function appendApiMessage(message: string, addition: string): string {
  return `${message}${message.endsWith("。") ? "" : "。"}${addition}`;
}

type ApiErrorMessageOptions = {
  includeR18ThreadSettingHint?: boolean;
};

export function getApiErrorMessage(
  error: unknown,
  fallbackMessage: string,
  options: ApiErrorMessageOptions = {},
): string {
  if (error instanceof ApiError && error.code) {
    if (error.code === "SPAM_REJECTED") {
      return (
        getServerMessage(error, LEGACY_SPAM_REJECTED_MESSAGE) ??
        API_ERROR_MESSAGES.SPAM_REJECTED
      );
    }
    if (error.code === "NSFW_REJECTED") {
      const categoryReason = getServerMessage(
        error,
        LEGACY_NSFW_REJECTED_MESSAGE,
      );
      const message = categoryReason
        ? appendApiMessage(categoryReason, NSFW_IMAGE_CHANGE_MESSAGE)
        : NSFW_REJECTED_MESSAGE;
      return options.includeR18ThreadSettingHint
        ? `${message}。${R18_THREAD_SETTING_HINT}`
        : message;
    }
    if (Object.hasOwn(API_ERROR_MESSAGES, error.code)) {
      const mappedMessage = API_ERROR_MESSAGES[error.code];
      if (mappedMessage) return mappedMessage;
    }
  }
  if (error instanceof ApiError && error.status === 400) {
    return BAD_REQUEST_MESSAGE;
  }
  if (
    error instanceof Error &&
    error.message &&
    !/^HTTP \d+$/.test(error.message)
  ) {
    return error.message;
  }
  return fallbackMessage;
}

export function isMissingThreadError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}
